// https://github.com/baianat/vee-validate
import * as VeeValidate from "vee-validate";
import fr from "@extracadabra/i18n/fr-FR/validations";
import { DatesHelpers } from "@core/helpers";
// import fr from "vee-validate/dist/locale/fr.json";

import { defineRule } from "vee-validate";
import * as AllRules from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";

export default function configureVeeValidate(VueInstance) {
  // @todo: adjust needed rules since it can slow down the app to load everything
  Object.keys(AllRules).forEach((rule) => {
    if (typeof AllRules[rule] === "function") {
      defineRule(rule, AllRules[rule]);
    }
  });

  // override required rule as in v4, field with false as a value does not pass validation
  defineRule("required", (value) => {
    return value === false || !!value;
  });

  defineRule("isSameOrBeforeToday", (value) => {
    const today = DatesHelpers.getDayjs();
    const valueDate = DatesHelpers.getDayjs(value, "DD/MM/YYYY");
    return valueDate.isSameOrBefore(today, "day");
  });

  defineRule("isAfterToday", (value) => {
    const today = DatesHelpers.getDayjs();
    const valueDate = DatesHelpers.getDayjs(value, "DD/MM/YYYY");
    return valueDate.isAfter(today, "day");
  });

  defineRule("isSameOrAfterToday", (value) => {
    const today = DatesHelpers.getDayjs();
    const valueDate = DatesHelpers.getDayjs(value, "DD/MM/YYYY");
    return valueDate.isSameOrAfter(today, "day");
  });

  defineRule("isSameOrBeforeThisYear", (value) => {
    const today = new Date().getFullYear();
    return Number(value) <= Number(today);
  });

  defineRule("isValidDate", (value) => {
    const date = DatesHelpers.getDayjs(value, "DD/MM/YYYY", true);
    return date.isValid();
  });

  defineRule("isXXYearsOld", (value, [currentAge]) => {
    const birthYear = DatesHelpers.getDayjs(value, "DD/MM/YYYY");
    const age = DatesHelpers.getDayjs().diff(birthYear, "year", false);
    return age >= currentAge;
  });

  defineRule("confirmed", (value, { toConfirmFieldValue }) => {
    // due to a bug in case password first character is '@', a solution is top pass the password splitted as an array
    // in order to compare its value, we need to join array to make it a string
    return value && value === toConfirmFieldValue.join("");
  });

  defineRule("after", (value, [label, date]) => {
    const startDate = DatesHelpers.getDayjs(date, "DD/MM/YYYY");
    const endDate = DatesHelpers.getDayjs(value, "DD/MM/YYYY");

    if (value !== "undefined" && date && startDate.isValid() && endDate.isValid()) {
      const diff = endDate.diff(startDate);
      return diff > 0;
    }

    return true;
  });

  defineRule("decimal", (value, [nb]) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: true,
      };
    }
    if (Number(nb) === 0) {
      return {
        // value must be an integer
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = !nb ? "+" : `{1,${nb}}`;
    // Test if value is an integer or a float, positive or negative
    // Number of decimals must be limited to the specified range
    // ... or unlimited if decimals number is not specified
    const regex = new RegExp(`^[-+]?\\d*(\\.\\d${regexPart})?$`);

    return {
      valid: regex.test(value),
    };
  });

  defineRule("rangeWithMask", (value, [min, max]) => {
    // as we use a mask, remove all whitespaces from input value
    const cleanedValue = value.replace(/\s+/g, "");
    return cleanedValue.length >= min && cleanedValue.length <= max;
  });

  defineRule("not_start_with_spaces", (value) => {
    if (!value || value.trim() === "") {
      return false;
    }
    return true;
  });

  VeeValidate.configure({
    generateMessage: localize("fr", fr),
  });
}
